module.exports = __webpack_public_path__ + "media/images/mailer/thumb_632-876f6cc47cc7966fa1155b1b924ee01a.jpg";